import { SALESFORCE_DATA_SOURCE_TYPE } from '@/constants/data_sources';
import {
  CLOUDFLARE_SALESFORCE_PROXY,
  FEATURE_FLAG,
  MULTI_SELECT_SF,
} from '@/constants/feature_flags';
import { useFeatureFlagStore } from '@/stores';
import type { DataSourceType } from '@/types/sources';

export default function useSalesforceProxyGate() {
  const { hasFeatureFlag } = useFeatureFlagStore();

  function isProxyUrlApplicable(
    integrationType: DataSourceType | null,
  ): boolean {
    return (
      integrationType === SALESFORCE_DATA_SOURCE_TYPE &&
      hasFeatureFlag(CLOUDFLARE_SALESFORCE_PROXY) &&
      !hasFeatureFlag(MULTI_SELECT_SF) &&
      /* The JWT flow bypasses the proxy, so the authorize endpoint refuses a
         base_url for it. */
      !hasFeatureFlag(FEATURE_FLAG.TEMP_SFDC_JWT_FIELDS)
    );
  }

  return { isProxyUrlApplicable };
}
